import React, { useEffect, useState } from "react";
import { useAppContext } from "@components/AppContext";
import { W0, W1 } from "@components/Constants";

import MyProfile from "@components/MyProfile";
import PersonalAccessTokensTable from "@components/PersonalAccessTokens";
import { type AppContext } from "@components/AppContext/types";
import { isPersonalAccessTokensEnabled } from "@components/Organization";

const SettingsMyProfilePage = (): JSX.Element => {
  const {
    identity,
    getOrganizationId,
    updateIdentityMobile,
    updateIdentityIs2FaEnabled,
  } = useAppContext() as AppContext & {
    updateIdentityMobile?: (mobile: string) => void;
    updateIdentityIs2FaEnabled?: (is2FaEnabled: boolean) => void;
  };

  const givenName = identity?.givenName;
  const familyName = identity?.familyName;
  const email = identity?.email;
  const mobile = identity?.mobile;
  const [ is2FaEnabled, setIs2FaEnabled ] = useState(identity?.is2FaEnabled);

  const fullName = `${givenName || ""} ${familyName || ""}`.trim();
  const style = {
    padding: `${W1}px ${W1 + W0}px`,
  };
  // NOTE: the profile description list stays narrow, the tokens table needs
  //       the full width of the settings pane for its columns.
  const profileStyle = {
    maxWidth: 650,
  };
  const personalAccessTokensStyle = {
    marginTop: W1 + W0,
  };
  // NOTE: personal access tokens have their own list of organizations, and
  //       the external investor portal has a separate one.
  const shouldShowPersonalAccessTokens = isPersonalAccessTokensEnabled(getOrganizationId());
  const onSuccessSwitch2Fa = async (shouldEnable: boolean) => {
    setIs2FaEnabled(shouldEnable);
    updateIdentityIs2FaEnabled?.(shouldEnable);
  };
  const onSuccessUpdateMobile = (updatedMobile: string) => {
    updateIdentityMobile?.(updatedMobile);
  };

  useEffect(() => {
    setIs2FaEnabled(identity?.is2FaEnabled);
  }, [ identity?.is2FaEnabled ]);

  return (
    <div style={style}>
      <div style={profileStyle}>
        <MyProfile
          userId={identity?.id || ""}
          name={fullName}
          email={email}
          mobile={mobile}
          is2FaEnabled={is2FaEnabled}
          onSuccessUpdateMobile={onSuccessUpdateMobile}
          onSuccessSwitch2Fa={onSuccessSwitch2Fa}
        />
      </div>

      {shouldShowPersonalAccessTokens && (
        <div style={personalAccessTokensStyle}>
          <PersonalAccessTokensTable />
        </div>
      )}
    </div>
  );
};

export default SettingsMyProfilePage;
